import React from 'react';
import {Card, Row, Col, Container} from 'react-bootstrap';
import Button from '@/components/ui/Button';
import i18n from 'i18n';
import {useNavigate} from 'react-router-dom';

const NoAccessView: React.FC = () => {
    const navigate = useNavigate();

    const handleBackToLogin = () => {
        window.location.href = '/auth/login';
    };

    const handleGoToDashboard = () => {
        navigate('/');
    };

    return (
        <Container className="mt-5">
            <Row className="justify-content-center">
                <Col md={8} lg={6}>
                    <Card className="shadow-sm">
                        <Card.Body className="text-center p-5">
                            <div className="mb-4">
                                <i className="fas fa-lock text-danger" style={{fontSize: '4rem'}}></i>
                            </div>
                            
                            <h2 className="text-danger mb-3">
                                {i18n.t('jt_access_denied.text')}
                            </h2>
                            
                            <p className="text-muted mb-4 lead">
                                {i18n.t('jt_you_do_not_have_required_access.text')}
                            </p>
                            
                            <div className="mb-4">
                                <p className="text-muted">
                                    {i18n.t('jt_no_access_explanation.text')}
                                </p>
                            </div>

                            <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center">
                                <Button
                                    variant="primary"
                                    onClick={handleBackToLogin}
                                    className="px-4"
                                >
                                    <i className="fas fa-sign-in-alt me-2"></i>
                                    {i18n.t('jt_back_to_login.text')}
                                </Button>
                                
                                <Button
                                    variant="outline-secondary"
                                    onClick={handleGoToDashboard}
                                    className="px-4"
                                >
                                    <i className="fas fa-home me-2"></i>
                                    {i18n.t('jt_go_to_dashboard.text')}
                                </Button>
                            </div>

                            <hr className="my-4" />
                            
                            <div className="text-muted small">
                                <p className="mb-1">
                                    <i className="fas fa-info-circle me-1"></i>
                                    {i18n.t('jt_need_help_contact_admin.text')}
                                </p>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default NoAccessView;